import global from "@/locales/en-UK/global";
import error403 from "@/locales/en-UK/errors/403";
import error404 from "@/locales/en-UK/errors/404";
import error500 from "@/locales/en-UK/errors/500";
import error503 from "@/locales/en-UK/errors/503";
import error504 from "@/locales/en-UK/errors/504";
import maintenance from "@/locales/en-UK/auth/maintenance";
import toast from "@/locales/en-UK/toast/toast";
import login from "@/locales/en-UK/auth/login";
import onboarding from "@/locales/en-UK/auth/onboarding";
import loginPageSteps from "@/locales/en-UK/loginPageSteps";
import dashboard from "@/locales/en-UK/dashboard/dashboard";
import account from "@/locales/en-UK/account/account";
import mailbox from "@/locales/en-UK/account/mailbox";
import bankstatement from "@/locales/en-UK/account/bankstatement";
import myApps from "@/locales/en-UK/my-apps/myApps";
import about from "@/locales/en-UK/about/about";
import contactService from "@/locales/en-UK/about/contactService";
import salesPromotions from "@/locales/en-UK/sales/promotions";
import brochures from "@/locales/en-UK/sales/brochures";
import shop from "@/locales/en-UK/shop/data";
import priceList from "@/locales/en-UK/shop/priceList";
import staff from "@/locales/en-UK/dashboard/staff";
import promotions from "@/locales/en-UK/promotions";
import points from "@/locales/en-UK/points";
import trainings from "@/locales/en-UK/trainings/trainings";
import vouchers from "@/locales/en-UK/vouchers/vouchers";
import generateReport from "@/locales/en-UK/generate-report/generateReport";
import widgets from "@/locales/en-UK/widgets/widgets";
import wholesaler from "@/locales/en-UK/wholesaler/wholesaler";
import media from "@/locales/en-UK/media/index";
import product from "@/locales/en-UK/product/index";
import message from "@/locales/en-UK/message/index";
import commitmentLetter from "@/locales/en-UK/account/commitmentLetter";
import multiplicator from "@/locales/en-UK/multiplicator";
import consents from "@/locales/en-UK/consents/consents";
import investment from "@/locales/en-UK/investment/data";
import kickback from "@/locales/en-UK/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Product Images",
    BDriveLinkText: "Link to the PRODUCT IMAGES portal",
  },
}

export default {
  locale: "en-UK",
  messages,
};
